import type { StatisticsTruncateType } from "../types/statistics/shared";

export const truncateTypes: StatisticsTruncateType[] = ["day", "week", "month", "year"] as const;
